import React from "react";
import { FiPlus } from "react-icons/fi";

// Bio page templates with pre-filled content
const BIO_TEMPLATES = [
  {
    id: "blank",
    name: "Start from Scratch",
    category: "all",
    theme: "light",
    title: "",
    description: "",
    links: [],
    social_links: {},
    style: {
      buttonShape: "rounded-md",
      buttonColor: "#37352f",
      buttonTextColor: "#ffffff",
      backgroundColor: "#f7f7f5",
      textColor: "#37352f",
    }
  },
  {
    id: "creator",
    name: "Content Creator",
    category: "link-in-bio",
    theme: "dark",
    title: "Your Name",
    description: "Content creator & storyteller ✨",
    links: [
      { title: "Latest Video", url: "https://youtube.com/watch?v=example", enabled: true },
      { title: "Subscribe to Newsletter", url: "https://newsletter.example.com", enabled: true },
      { title: "Shop My Favorites", url: "https://shop.example.com", enabled: true },
    ],
    social_links: { instagram: "", youtube: "", tiktok: "" },
    style: {
      buttonShape: "rounded-full",
      buttonColor: "#ffffff",
      buttonTextColor: "#191919",
      backgroundColor: "#191919",
      textColor: "#ffffff",
    }
  },
  {
    id: "business",
    name: "Business Card",
    category: "business-card",
    theme: "light",
    title: "Jane Smith",
    description: "Product Manager at TechCorp",
    links: [
      { title: "📧 Email Me", url: "mailto:jane@example.com", enabled: true },
      { title: "📅 Book a Meeting", url: "https://calendly.com/example", enabled: true },
      { title: "💼 LinkedIn", url: "https://linkedin.com/in/example", enabled: true },
    ],
    social_links: { linkedin: "", twitter: "", website: "" },
    style: {
      buttonShape: "rounded-sm",
      buttonColor: "#2383e2",
      buttonTextColor: "#ffffff",
      backgroundColor: "#ffffff",
      textColor: "#37352f",
    }
  },
  {
    id: "restaurant",
    name: "Restaurant & Cafe",
    category: "products",
    theme: "dark",
    title: "The Brew Coffee",
    description: "Artisan coffee • Open daily 7am-6pm",
    links: [
      { title: "📍 View Menu", url: "https://example.com/menu", enabled: true },
      { title: "📞 Call to Order", url: "tel:+1234567890", enabled: true },
      { title: "🗺️ Get Directions", url: "https://maps.google.com", enabled: true },
      { title: "⭐ Leave a Review", url: "https://google.com/review", enabled: true },
    ],
    social_links: { instagram: "", website: "" },
    style: {
      buttonShape: "rounded-lg",
      buttonColor: "#d4a574",
      buttonTextColor: "#1a1a1a",
      backgroundColor: "#1a1a1a",
      textColor: "#ffffff",
    }
  },
  {
    id: "wellness",
    name: "Wellness & Fitness",
    category: "products",
    theme: "light",
    title: "Oasis Wellness",
    description: "Relax • Refresh • Restore",
    links: [
      { title: "Book Appointment", url: "https://booking.example.com", enabled: true },
      { title: "Our Services", url: "https://example.com/services", enabled: true },
      { title: "Special Offers", url: "https://example.com/offers", enabled: true },
    ],
    social_links: { instagram: "", tiktok: "", website: "" },
    style: {
      buttonShape: "rounded-full",
      buttonColor: "#0f766e",
      buttonTextColor: "#ffffff",
      backgroundColor: "#f0fdf4",
      textColor: "#064e3b",
    }
  },
  {
    id: "musician",
    name: "Musician / Artist",
    category: "link-in-bio",
    theme: "dark",
    title: "DJ Beats",
    description: "🎵 Producer • DJ • Music Lover",
    links: [
      { title: "▶️ New Single Out Now", url: "https://spotify.com/track/example", enabled: true },
      { title: "🎫 Upcoming Shows", url: "https://example.com/shows", enabled: true },
      { title: "🛒 Merch Store", url: "https://merch.example.com", enabled: true },
    ],
    social_links: { instagram: "", youtube: "", tiktok: "" },
    style: {
      buttonShape: "rounded-none",
      buttonColor: "#9333ea",
      buttonTextColor: "#ffffff",
      backgroundColor: "#0f0f0f",
      textColor: "#ffffff",
    }
  },
  {
    id: "portfolio",
    name: "Portfolio",
    category: "link-in-bio",
    theme: "light",
    title: "Alex Designer",
    description: "UI/UX Designer & Creative Director",
    links: [
      { title: "View Portfolio", url: "https://portfolio.example.com", enabled: true },
      { title: "Download Resume", url: "https://example.com/resume.pdf", enabled: true },
      { title: "Hire Me", url: "mailto:hire@example.com", enabled: true },
    ],
    social_links: { linkedin: "", github: "", website: "" },
    style: {
      buttonShape: "rounded-md",
      buttonColor: "#000000",
      buttonTextColor: "#ffffff",
      backgroundColor: "#fafafa",
      textColor: "#171717",
    }
  },
  {
    id: "hotel",
    name: "Hotel & Travel",
    category: "products",
    theme: "dark",
    title: "The Grand Hotel",
    description: "Your new escape awaits",
    links: [
      { title: "Book Your Stay", url: "https://booking.example.com", enabled: true },
      { title: "View Rooms", url: "https://example.com/rooms", enabled: true },
      { title: "Dining & Spa", url: "https://example.com/amenities", enabled: true },
    ],
    social_links: { instagram: "", website: "" },
    style: {
      buttonShape: "rounded-sm",
      buttonColor: "#d4c5b0",
      buttonTextColor: "#1a1a1a",
      backgroundColor: "#26282c",
      textColor: "#fffaf6",
    }
  },
  {
    id: "podcast",
    name: "Podcast",
    category: "link-in-bio",
    theme: "light",
    title: "The Daily Talk",
    description: "Conversations that matter 🎙️",
    links: [
      { title: "🎧 Listen on Spotify", url: "https://spotify.com/show/example", enabled: true },
      { title: "🍎 Apple Podcasts", url: "https://podcasts.apple.com/example", enabled: true },
      { title: "💬 Join Our Discord", url: "https://discord.gg/example", enabled: true },
      { title: "☕ Support the Show", url: "https://buymeacoffee.com/example", enabled: true },
    ],
    social_links: { twitter: "", instagram: "", youtube: "" },
    style: {
      buttonShape: "rounded-lg",
      buttonColor: "#f97316",
      buttonTextColor: "#ffffff",
      backgroundColor: "#fffbeb",
      textColor: "#78350f",
    }
  },
  {
    id: "ecommerce",
    name: "E-commerce / Shop",
    category: "products",
    theme: "light",
    title: "Style Studio",
    description: "Curated fashion & accessories ✨",
    links: [
      { title: "🛍️ Shop New Arrivals", url: "https://shop.example.com/new", enabled: true },
      { title: "🔥 Sale Items", url: "https://shop.example.com/sale", enabled: true },
      { title: "📦 Track Your Order", url: "https://shop.example.com/tracking", enabled: true },
    ],
    social_links: { instagram: "", tiktok: "", website: "" },
    style: {
      buttonShape: "rounded-full",
      buttonColor: "#ec4899",
      buttonTextColor: "#ffffff",
      backgroundColor: "#fdf2f8",
      textColor: "#831843",
    }
  },
];

const CATEGORIES = [
  { id: "all", name: "All Templates" },
  { id: "link-in-bio", name: "Link in Bio" },
  { id: "products", name: "Products & Services" },
  { id: "business-card", name: "Business Card" },
];

export default function BioTemplateGallery({ onSelectTemplate }) {
  const [selectedCategory, setSelectedCategory] = React.useState("all");
  const [hoveredTemplate, setHoveredTemplate] = React.useState(null);

  const filteredTemplates = BIO_TEMPLATES.filter(
    t => selectedCategory === "all" || t.category === selectedCategory || t.id === "blank"
  );

  return (
    <div className="template-gallery">
      <div className="template-gallery-header">
        <h1>Create Bio Page</h1>
      </div>
      <p className="template-gallery-subtitle">
        Choose a template to get started. You can customize everything later.
      </p>

      <div className="template-categories">
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            className={`template-category ${selectedCategory === cat.id ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat.id)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="template-grid">
        {filteredTemplates.map(template => (
          <div
            key={template.id}
            className={`template-card ${hoveredTemplate === template.id ? "hovered" : ""}`}
            onClick={() => onSelectTemplate(template)}
            onMouseEnter={() => setHoveredTemplate(template.id)}
            onMouseLeave={() => setHoveredTemplate(null)}
          >
            <div className="template-preview">
              {template.id === "blank" ? (
                <div className="template-blank">
                  <FiPlus />
                  <span>Blank</span>
                </div>
              ) : (
                <TemplatePreviewMini template={template} />
              )}
            </div>
            <div className="template-name">{template.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function TemplatePreviewMini({ template }) {
  const { style, title, description, links, theme } = template;
  const isDark = theme === "dark";

  return (
    <div
      style={{
        background: style.backgroundColor,
        height: "100%",
        padding: "24px 16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Avatar placeholder */}
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
          marginBottom: 12,
        }}
      />

      {/* Title */}
      <div
        style={{
          color: style.textColor,
          fontSize: 14,
          fontWeight: 600,
          textAlign: "center",
          marginBottom: 4,
        }}
      >
        {title || "Page Title"}
      </div>

      {/* Description */}
      <div
        style={{
          color: style.textColor,
          opacity: 0.7,
          fontSize: 10,
          textAlign: "center",
          marginBottom: 16,
        }}
      >
        {description || "Your description"}
      </div>

      {/* Links */}
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 6 }}>
        {(links.length > 0 ? links.slice(0, 3) : [{ title: "Link 1" }, { title: "Link 2" }]).map((link, i) => (
          <div
            key={i}
            style={{
              background: style.buttonColor,
              color: style.buttonTextColor,
              padding: "8px 12px",
              borderRadius: getBorderRadius(style.buttonShape),
              fontSize: 10,
              textAlign: "center",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {link.title}
          </div>
        ))}
      </div>
    </div>
  );
}

function getBorderRadius(shape) {
  switch (shape) {
    case "rounded-none": return "0";
    case "rounded-sm": return "4px";
    case "rounded-md": return "8px";
    case "rounded-lg": return "12px";
    case "rounded-full": return "9999px";
    default: return "8px";
  }
}

export { BIO_TEMPLATES, CATEGORIES };
